

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "assets/theme-dark/base/colors";
import appScaleGlobals from "assets/theme/base/appScale";
import { FONT_MONO, MONO_FONT_CLASS, monoTabularProps } from "styles/tokens/typography";

const { info, dark, background, text } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  body: {
    backgroundColor: background.default,
    color: text.main,
    fontFamily: '"Hanken Grotesk", "Inter", "Helvetica", "Arial", sans-serif !important',
  },
  "#app": {
    minHeight: "100vh",
    backgroundColor: background.default,
  },
  ":root": {
    "--font-mono": FONT_MONO,
  },
  [`code, pre, kbd, samp, .${MONO_FONT_CLASS}, [data-font="mono"], [data-table-data-cell], [data-table-data-cell] .MuiTypography-root`]: {
    fontFamily: "var(--font-mono) !important",
    fontWeight: 400,
    ...monoTabularProps,
  },
  ".MuiTableCell-body, .MuiTableCell-body .MuiTypography-root": {
    fontFamily: "var(--font-mono) !important",
    fontWeight: 400,
    ...monoTabularProps,
  },
  ...appScaleGlobals,
};

export default globals;
